import React, { useContext, Dispatch, useState,useEffect, useRef, SetStateAction, useMemo, startTransition, Suspense } from "react";
import { Link } from "react-router-dom";
import './TopBar.css'
import logoWhite from '../../../image/logo/logoWhite.webp'
import { FaMapMarkerAlt, FaLocationArrow} from "react-icons/fa";
import { LiaSlidersHSolid } from "react-icons/lia";
import { AppContext } from "../../../context/AppContext";
import { Restaurant } from "../../../components/types/types";
import axios from "axios";
import { Coordonates } from "../../../components/types/types";
import { TfiClose } from "react-icons/tfi";
import IconConnection from "../../../components/iconConnection/iconConnection";
import { ImMap2 } from "react-icons/im";

import { GoSearch } from "react-icons/go";
import { PiCalendarDotsLight } from "react-icons/pi";
import { CiClock2 } from "react-icons/ci";
import { useNavigate } from "react-router-dom";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";

const  RestoSearchBar = React.lazy(() => import("../../../components/restoSearchBar/restoSearchBar"));
const Calendar = React.lazy(() => import("../../../components/CalandarTopBar/calandarLazy"));
const TIME_FILTERS = new Set(["Ouvert ce midi","Ouvert ce soir"]);
function clearTimeFilters(setListFilter:Dispatch<SetStateAction<(string | number | [number, number])[]>>, currentList: (string|number|[number,number])[]) {
  if (!currentList.some(x => TIME_FILTERS.has(x as string))) return false;
  setListFilter(prev => prev.filter(x => !TIME_FILTERS.has(x as string)));
  return true;
}
function clearProximity(setListFilter:Dispatch<SetStateAction<(string | number | [number, number])[]>>, currentList: (string|number|[number,number])[]) {
 if (currentList.includes('A proximité')) {
    setListFilter(prev => prev.filter(x => x !== 'A proximité'));
    return
  } else return; 
}

interface ContainerShowCityProps {
    clickProximity: () => void,
    suggestionsCity: villesProps[],
    setShowCity: Dispatch<SetStateAction<boolean>>,
    setSearchCity: Dispatch<SetStateAction<string>>,
    clearProximity:() => void
}

const ContainerShowCity:React.FC<ContainerShowCityProps> = ({clickProximity,suggestionsCity,setShowCity,setSearchCity,clearProximity}) => {
    const navigate = useNavigate()
    return (
        <>
            <div className="elem pointer" onClick={() => {clickProximity();navigate('/restaurants-a-proximite')}}>
                <FaLocationArrow size={13} />
                <p key={"city-1"}>A proximité</p>
            </div>
            {
                suggestionsCity.length > 0 && <>
                    <div className="borderCity"></div>
                    {suggestionsCity.map((ville, index) => (
                        <div className="elem pointer" onClick={() => {navigate(`/${ville.name}`);setShowCity(false);setSearchCity(ville.name);clearProximity()}}>
                            <FaMapMarkerAlt size={15} />
                            <p key={"city-"+index}>{ville.name}</p>
                        </div>
                    ))}
                </>
            }
        </>
    )
}

interface ContainerSuggestionProps {
    suggestions:Restaurant[],
}

const ContainerSuggestion:React.FC<ContainerSuggestionProps> = ({suggestions}) => {
    return (
        <>
            {
                suggestions.map((elem,id) => {
                    return <div key={"suggestion"+id} style={{width:'100%'}}>
                         <Suspense fallback={null}>
                    <RestoSearchBar name={elem.name} id_url={elem.id_url} city={elem.address[1]} devanture={elem.devanture} type={elem.type} nbrReview={elem.nbr_review} note={elem.note}/>
                    </Suspense>
                    {id < suggestions.length -1 && <div className="border"></div>}
                    </div>
                })
            }
        </>
    )
}

interface ContainerCalendarProps {
    today: Date,
    maxDate:Date,
    activeMonth:Date,
    setActiveMonth:Dispatch<SetStateAction<Date>>,
    setShowCalendar:Dispatch<SetStateAction<boolean>>
}
const ContainerCalendar:React.FC<ContainerCalendarProps> = ({today,maxDate,activeMonth,setActiveMonth,setShowCalendar}) => {
    const {setDate_selected,date_selected,setFilterChoose,filterChoose} = useContext(AppContext)
    const fourMonthsLater = new Date();
    fourMonthsLater.setMonth(today.getMonth() + 3);

    const handleActiveStartDateChange = ({ activeStartDate }: { activeStartDate: Date | null }) => {
        if (activeStartDate) {
            setActiveMonth(activeStartDate); 
        }
    };
    const handleClickDay = (date:Date) => {
        setShowCalendar(false)
        clearTimeFilters(setFilterChoose,filterChoose)
        if(date_selected?.getTime() === date.getTime()) setDate_selected(null)
        else setDate_selected(date)
      };
    return (
        <Suspense fallback={null}>
            <Calendar
                minDate={today}
                maxDate={maxDate}
                value={date_selected || today}
                onActiveStartDateChange={handleActiveStartDateChange}
                onClickDay={(date) => {
                    handleClickDay(date);
                }}
                tileClassName={({ date, view }: TileClassNameProps) => {
                    if (view === "month") {
                        const isSameMonth =
                        date.getMonth() === activeMonth.getMonth() &&
                        date.getFullYear() === activeMonth.getFullYear();

                        if (
                            date_selected &&
                            date.getDate() === date_selected.getDate() &&
                            date.getMonth() === date_selected.getMonth() &&
                            date.getFullYear() === date_selected.getFullYear()
                            ) {
                            return "date_select";
                        }

                        if (
                            date.getDate() === today.getDate() &&
                            date.getMonth() === today.getMonth() &&
                            date.getFullYear() === today.getFullYear()
                            ) {
                            return "current_Date";
                        }
                            

                        if (date < today || date > fourMonthsLater) {
                            return "lockDay";
                        }

                        if (
                            (date.getDay() === 6 || date.getDay() === 0) &&
                            isSameMonth &&
                            date.getTime() < maxDate.getTime()
                            ) {
                        return "weekEnd";
                        }

                        return "futureDay";
                    }

                    return null;
                }}
                view="month"
                showNeighboringMonth={true}
                navigationLabel={({ label }) => (
                    <span className="midTitle" >
                        {label.charAt(0).toUpperCase() + label.slice(1)}
                    </span>
                )}
            />     
        </Suspense>
    )
}

type TileClassNameProps = {
    date: Date;
    view: string;
  };

interface TopBarProps {
    listBase:Restaurant[],
    lengthResto:number
}


interface villesProps {
    name:string,
    latitude:string,
    longitude:string,
}

const TopBar:React.FC<TopBarProps> = ({listBase}) => {

    const {valueSearchCity,setValueSearchCity,showFilterTel,filterChoose,setFilterChoose,setShowFilterTel,setCurrentHomePage,searchCity,setSearchCity,setCoordonates,setSearchValueHome,setDate_selected,date_selected,hour_selected,setHour_selected, setPreferencesCookies} = useContext(AppContext)

    const [valueSearchBar,setValueSearchBar] = useState('')
    const [suggestions, setSuggestions] = useState<Restaurant[]>([]);
    const [openTopBar,setOpenTopBar] = useState<boolean>(true)
    const [showChevron,setShowChevron] = useState<boolean>(false)

    const [activeTopBar,setActiveTopBar] = useState(false)
    const [showOveflow,setShowOverflow] = useState(true)

    const [suggestionsCity, setSuggestionsCity] = useState<villesProps[]>([])
    const [showSearch,setShowSearch] = useState(false)

    const [showCity,setShowCity] = useState(false)
    const [showCalendar,setShowCalendar] = useState<boolean>(false)
    const [showHour,setShowHour] = useState<boolean>(false)
    const [activeMonth, setActiveMonth] = useState(new Date());

    useEffect(() => {

        if (window.innerWidth > 768) return;
        
        const handleScroll = () => {
          const scrollTop = window.scrollY;
          if (justClickedCityRef.current) return;
          if(openTopBar && setOpenTopBar) {
            if(scrollTop > 250) {
                setShowCity(false)
                setShowCalendar(false)
                setShowHour(false)
                setActiveTopBar(false)
            }

            if(scrollTop > 130) {
                setTimeout(() => {
                    const inputSearchFocused = refInputSearchPhone.current === document.activeElement;
                    const inputCityFocused = refInputCityPhone.current === document.activeElement;
                    const hasFocus = inputSearchFocused || inputCityFocused;    
                    if(!hasFocus) {
                        setOpenTopBar(false);
                        setShowOverflow(false)}
                },70);
            }else {
                setOpenTopBar(true);
                setTimeout(() => {if(scrollTop <= 130)setShowOverflow(true)}, 200);
            }
          }
          setTimeout(() => {
            if (scrollTop <= 130) {
                setOpenTopBar(true);
                setTimeout(() => {
                    if (window.scrollY <= 130) {
                        setShowOverflow(true);
                    }
                }, 200);
            }},50)
          if(setShowChevron) setShowChevron(scrollTop > 130)
        };
      
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    useEffect(() => {
        if (activeTopBar) {
            document.body.style.overflowY = 'hidden'
        } else {
            document.body.style.overflowY = 'auto'
        }
    
        return () => {
            document.body.style.overflowY = 'auto'
        };
    }, [activeTopBar])
   
    const justClickedCityRef = useRef(false)

    const today = new Date();
    const refIconCalendar = useRef<HTMLInputElement>(null)
    const refCalendar = useRef<HTMLInputElement>(null)
    const refIconHour = useRef<HTMLInputElement>(null)
    const refHour = useRef<HTMLInputElement>(null)
    const refSearch = useRef<HTMLInputElement>(null)
    const refCity = useRef<HTMLInputElement>(null)


    const refCalendarPhone = useRef<HTMLInputElement>(null)
    const refHourPhone = useRef<HTMLInputElement>(null)
    const refSearchPhone = useRef<HTMLInputElement>(null)
    const refCityPhone = useRef<HTMLInputElement>(null)

    const refInputSearchPhone = useRef<HTMLInputElement>(null)
    const refInputCityPhone = useRef<HTMLInputElement>(null)

    useEffect(() => {
        if (valueSearchCity.length > 0) { 
          axios.post(`${process.env.REACT_APP_DIRECTION_REQUEST}/api/getVille`, { name: valueSearchCity })
            .then(response => {
                setSuggestionsCity(response.data); 
            })
            .catch(error => {
              console.error('Erreur lors de la recherche des villes:', error);
            })
        } else {
          setSuggestionsCity([]); 
        }
      }, [valueSearchCity]);


    useEffect(() => {
        const timeout = setTimeout(() => {
            if (!valueSearchBar) {
                setSuggestions([]);
                return;
            }
            const lowerCaseSearch = valueSearchBar.toLowerCase().replace(/[\u2019\u2018\u2032\u00B4`]/g, "'") ;
            const matches = listBase.reduce<{
                start: Restaurant[];
                includes: Restaurant[];
            }>(
                (acc, elem) => {
                    const name = elem.name.toLowerCase().replace(/[\u2019\u2018\u2032\u00B4`]/g, "'");
                    if (name.startsWith(lowerCaseSearch)) {
                        acc.start.push(elem);
                    } else if (name.includes(lowerCaseSearch)) {
                        acc.includes.push(elem);
                    }
                    return acc;
                },
                { start: [], includes: [] }
            );
            setSuggestions([...matches.start, ...matches.includes].slice(0, 5));
        }, 300);
        return () => clearTimeout(timeout);
    }, [valueSearchBar]);
    

    const handleClick = () => {
        setShowFilterTel(!showFilterTel);
    }; 

    const changeSearchBar = (event: React.FocusEvent<HTMLInputElement>) => {
        setValueSearchBar(event.target.value)
    }
    const changeSearchCityBar = (event: React.FocusEvent<HTMLInputElement>) => {
        setValueSearchCity(event.target.value)
        if(valueSearchCity === '') {
            navigate('/')
            setSearchCity('')
            setCoordonates({latitude:"",longitude:""})
        }
    }
    const changeSearchTopBar = (newElem:string) => {
        setShowSearch(false)
        setSearchValueHome(newElem)
        setCurrentHomePage(1)
        setTimeout(() => {setOpenTopBar(true)},300)
    }
    const launchSearch = () => {
        setShowSearch(false)
        setSearchValueHome(valueSearchBar)
        setCurrentHomePage(1)
        setTimeout(() => {setOpenTopBar(true)},300)
    }


    const inputSearchKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if(event.key === 'Enter') changeSearchTopBar((event.target as HTMLInputElement).value)
    }

    const handleClickInput = () => {
        setOpenTopBar(true)
        startTransition(() => {setShowSearch(true)});
        document.addEventListener('mouseup', handleClickOutsideSearch);
    }

    const handleClickCity = () => {
        justClickedCityRef.current = true;
        setShowCity(true)
        setTimeout(() => {
            document.addEventListener('mouseup', handleClickOutsideCity);
        }, 50);
        setTimeout(() => {
            justClickedCityRef.current = false;
        }, 300);
    }
    const handleClickOutsideCity = (event: MouseEvent) => {
        if (refCity.current && !refCity.current.contains(event.target as Node) && refCityPhone.current && !refCityPhone.current.contains(event.target as Node)) {
            setShowCity(false)
            document.removeEventListener('mouseup', handleClickOutsideCity);
        }
    }
    const handleClickOutsideSearch= (event: MouseEvent) => {
        if (refSearch.current && !refSearch.current.contains(event.target as Node) && refSearchPhone.current && !refSearchPhone.current.contains(event.target as Node)) {
            setShowSearch(false)
            ;
        }
    }
    useEffect(() => {
        if (showCalendar) {
          document.addEventListener('mouseup', handleClickOutsideCalendar);
        } 
        else {
            document.removeEventListener('mouseup', handleClickOutsideSearch)
        }

      }, [showCalendar]);
      const handleClickOutsideCalendar = (event: MouseEvent) => {
        if (refCalendar.current && !refCalendar.current.contains(event.target as Node) && refIconCalendar.current && !refIconCalendar.current.contains(event.target as Node) && refCalendarPhone.current && !refCalendarPhone.current.contains(event.target as Node) ) {
          setShowCalendar(false); 
          document.removeEventListener('mouseup', handleClickOutsideSearch)
        }
      };
    useEffect(() => {
        if (showHour) {
          document.addEventListener('mouseup', handleClickOutsideHour);
        } 
        else {
            document.removeEventListener('mouseup', handleClickOutsideHour)
        }

      }, [showHour]);
      const handleClickOutsideHour = (event: MouseEvent) => {
        if (refHour.current && !refHour.current.contains(event.target as Node) && refIconHour.current && !refIconHour.current.contains(event.target as Node) && refHourPhone.current && !refHourPhone.current.contains(event.target as Node)) {
          setShowHour(false); 
          document.removeEventListener('mouseup', handleClickOutsideSearch)
        }
      };


    const clickProximity = () => {
        setValueSearchCity("Chargement...")
        const inputCity = document.querySelector('.inputCity') as HTMLInputElement;
        inputCity.classList.add('loading');
        inputCity.disabled = true;
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const userLocation:Coordonates = {
                        latitude: position.coords.latitude.toString(),
                        longitude: position.coords.longitude.toString(),
                    };
                    setSearchCity("A proximité");
                    setValueSearchCity("A proximité")
                    setCoordonates(userLocation); 
                    inputCity.disabled = false;
                    inputCity.classList.remove('loading');
                },

                (error) => {
                    console.error("Erreur lors de la récupération de la localisation :", error.message);
                    if(searchCity === "" ) {
                        setSearchCity("");
                        setValueSearchCity("")
                    }
                    else {
                        setValueSearchCity(searchCity)
                    }
                    inputCity.classList.remove('loading');
                    inputCity.disabled = false;
                }
            );
        } else {
            console.error("Geolocation n'est pas supportée par ce navigateur.");
            setSearchCity("");
            setValueSearchCity("")
        }
        setShowCity(false)
        document.removeEventListener('mouseup', handleClickOutsideCity);
    }

        const generateTimeSlots = () => {
            const times = [];
            for (let h = 0; h < 24; h++) {
                for (let m = 0; m < 60; m += 30) {
                    const hour = h.toString().padStart(2, "0");
                    const minute = m.toString().padStart(2, "0");
                    times.push(`${hour}h${minute}`);
                }
            }
            return times;
        };
        const timeSlots = useMemo(() => generateTimeSlots(), []);

        const getClosestTimeSlot = () => {
            if(hour_selected) return hour_selected
            else {
                const now = new Date();
                const hours = now.getHours();
                const minutes = now.getMinutes();
                const roundedMinutes = minutes < 30 ? "30" : "00";
                const nextHour = minutes < 30 ? hours : (hours + 1) % 24;
                return `${nextHour.toString().padStart(2, "0")}h${roundedMinutes}`;
           }
        };
    
        useEffect(() => {
            if (showHour) {
                const closestTime = getClosestTimeSlot(); 
                const containerPhone = document.getElementById("containerHourTopBarPhone");
                const container = document.getElementById("containerHourTopBar");
                const hour = parseInt(closestTime.split("h")[0], 10) || 0;
                
                if (container) {
                    const elementHeight = 90;
                    const scrollTop = hour * elementHeight + (hour > 15 ? 100 : 0);
                    container.scrollTo({
                        top: scrollTop,
                        behavior: "auto",
                    });
                }
                if (containerPhone) {
                    const elementHeight = 80;
                    const scrollTop = hour * elementHeight + (hour > 15 ? (hour > 20 ? 90 : 75) : 0);
                    containerPhone.scrollTo({
                        top: scrollTop,
                        behavior: "auto",
                    });
                }
            }
        }, [showHour]);
    
        

    const handleCalendar = () => {
        startTransition(() => {setShowCalendar(!showCalendar)});
        setActiveMonth(date_selected ? date_selected : new Date)
    }

    const formatSelectedDate = (date: Date | null): string => {
        if (!date) {
            return "Date"; 
        }
    
        const today = new Date();
        if (
            date.getDate() === today.getDate() &&
            date.getMonth() === today.getMonth() &&
            date.getFullYear() === today.getFullYear()
        ) {
            return "Auj.";
        }
        const showDate =  date.toLocaleDateString("fr-FR", {
            day: "numeric",
            month: "short",
            
        })
        const [day,month] = showDate.split(" ")

        return `${day} ${month[0].toUpperCase()+month.slice(1)} `
        
    };

    const maxDate = new Date();
    maxDate.setMonth(maxDate.getMonth() + 3);
    useEffect(() => {
        if(showHour ||showCalendar || (showSearch && valueSearchBar) || (showCity && valueSearchCity)) {
            setActiveTopBar(true)
        }
        else setActiveTopBar(false)
        
    },[showCalendar,showHour,showCity,showSearch,valueSearchBar,valueSearchCity])

    const {setShowCookies} = useContext(AppContext)
    const navigate = useNavigate()

    const handleMap = () => {
        const cookie = document.cookie.split('; ').find(row => row.startsWith('QUELRESTO_COOKIE='));
        if (cookie) {
            const cookieValue = cookie.split('=')[1];
            try {
                const decode = decodeURIComponent(cookieValue)
                const cookieData = JSON.parse(decode);
                if (cookieData['perform-analytics']) {
                    setShowFilterTel(false)
                    navigate(`/map?via=home`);
                } else {
                    setShowCookies(true)
                    setPreferencesCookies(true)
                }
            } catch (error) {
                setShowCookies(true)
                setPreferencesCookies(true)
            }
        } else {
            setShowCookies(true)
            setPreferencesCookies(true)
        }
    }

    const handleCloseTopBar = () => {
        const scrollTop = window.scrollY;
        setTimeout(() => {
            if(scrollTop > 130) {
                const inputSearchFocused = refInputSearchPhone.current === document.activeElement;
                const inputCityFocused = refInputCityPhone.current === document.activeElement;
                const hasFocus = inputSearchFocused || inputCityFocused;    
                if(!hasFocus) {
                    setOpenTopBar(false);
                    setShowOverflow(false)
                }  
            }
        },70)
    }

    return (

        <div className='DoubleTopBarHome'>
            <div className="TopBar" >
                <Link to={"/"} className={`containerLogo  ${openTopBar ? 'open' : 'closed'}`}>
                    <img className="logoTopBar" src={logoWhite} loading="lazy" alt="logo" />
                </Link>


                <div className={`containerSearchBarPhone  ${openTopBar ? 'open' : ''}`} style={{overflow:!openTopBar ? 'hidden' :  (showOveflow ? 'visible' : 'hidden')}}>
                    <div className='firstInput primaryBack' onClick={handleClickInput} ref={refSearchPhone}>
                        <GoSearch color="black" className="searchIconPhone" size={20} />
                        <form onSubmit={(e) => {
                            e.preventDefault();
                            refInputSearchPhone.current?.blur();
                            changeSearchTopBar(valueSearchBar);
                        }} style={{width:'100%'}}>
                        <input type="search" ref={refInputSearchPhone} className='inputTopBar midText' enterKeyHint="search" placeholder="Rechercher un restaurant..." style={{backgroundColor:"transparent"}} value={valueSearchBar} onChange={changeSearchBar}  onKeyDown={(e) => {if (e.key === 'Enter') { const target = e.target as HTMLInputElement;target.blur(); launchSearch();}}} maxLength={50}/></form>
                        {valueSearchBar && <TfiClose className="resetTopBar pointer" size={17} onClick={() => {setValueSearchBar("");changeSearchTopBar('')}}/> }  
                        {
                            showSearch && suggestions.length > 0 && <div className="containerSuggestion primaryBack" ref={refSearchPhone}>
                                <ContainerSuggestion suggestions={suggestions} />
                            </div>
                        }
                    </div>
                    <div className="secondInput primaryBack" onClick={() => {setOpenTopBar(true);setShowOverflow(true)}}>
                        <FaMapMarkerAlt color="black" size={18} />
                        <input type="search" ref={refInputCityPhone} className="inputTopBar inputCity midText" enterKeyHint="search" id={"inputCity"} placeholder="Ville ..." style={{backgroundColor:"transparent"}} value={valueSearchCity} onChange={changeSearchCityBar}  maxLength={50} onClick={handleClickCity} autoComplete="new-password" name="q_addr" onFocus={(e) => e.currentTarget.setAttribute('autocomplete', 'new-password')}/>
                        {valueSearchCity && <TfiClose className="resetTopBar pointer" size={15} onClick={(e) => { e.stopPropagation();e.preventDefault();clearProximity(setFilterChoose,filterChoose); navigate('/');setValueSearchCity(""); setSearchCity("") ;setCoordonates({latitude:"",longitude:""}) }}/> }
                        <div className="separation"></div>
                        <PiCalendarDotsLight color={date_selected ? '#cb9e3A' : 'black'} size={20} onClick={handleCalendar}/>
                        <div className="separation"></div>
                        <CiClock2 color={hour_selected ? '#cb9e3A' : 'black'} size={18} onClick={() => setShowHour(!showHour)} />

                        {
                        showCalendar && (
                            <div className="containerCalendar" ref={refCalendarPhone}>
                                <ContainerCalendar today={today} activeMonth={activeMonth} setActiveMonth={setActiveMonth} setShowCalendar={setShowCalendar} maxDate={maxDate}/>
                            </div>
                        )
                        }

                        {showHour && (
                                <div id="containerHourTopBarPhone"  className="containerHourTopBar smallTextBold primaryBack" ref={refHourPhone}>
                                    {timeSlots.map((time, index) => (
                                        <div
                                            key={index}
                                            id={`time-${time.replace("h", "-")}`}
                                            className={`timeSlot ${time === hour_selected && 'select'}`}
                                            onClick={() => {
                                                clearTimeFilters(setFilterChoose,filterChoose)
                                                setHour_selected(time === hour_selected ? '' : time);
                                                setShowHour(false);
                                            }}
                                        >
                                            {time}
                                        </div>
                                    ))}
                                </div>
                        )}
                        {showCity && <div className="containerListCity smallText" ref={refCityPhone}>
                                <ContainerShowCity setSearchCity={setValueSearchCity} clickProximity={clickProximity} suggestionsCity={suggestionsCity} setShowCity={setShowCity} clearProximity={() => {clearProximity(setFilterChoose,filterChoose)}}/>
                            </div>
                        }
                    </div>
                </div> 
                <div className="containerSearchBar">
                        <div className={`containerInputCity ${showCity &&  'select'}`} onClick={handleClickCity} ref={refCity}>
                            
                            <FaMapMarkerAlt color="black" opacity="85%" size={18} />
                            <input type="search" className="inputTopBar inputCity midText" id={"inputCity"} placeholder="Ville ..." style={{backgroundColor:"transparent"}} value={valueSearchCity} onChange={changeSearchCityBar}  maxLength={50} autoComplete="new-password" name="q_addr" onFocus={(e) => e.currentTarget.setAttribute('autocomplete', 'new-password')}/>
                        
                             {valueSearchCity && (
                            <TfiClose className="resetTopBar pointer" size={13} onClick={(e) => {e.stopPropagation();e.preventDefault();clearProximity(setFilterChoose,filterChoose);  navigate('/');setValueSearchCity(""); setSearchCity("");setCoordonates({latitude:"",longitude:""}) }}/>)} 
                        </div>
                       
                        <div className="separation"></div>
                        <div className={`containerInputTopBar ${showSearch &&  'select'}`} onClick={handleClickInput} ref={refSearch}>
                                <GoSearch color="black" className="searchIcon" size={20} />
                                <input type="search" className='inputTopBar midText' placeholder="Rechercher un restaurant..." style={{backgroundColor:"transparent"}} value={valueSearchBar} onChange={changeSearchBar} onKeyDown={inputSearchKeyDown} maxLength={50}/>
                                  {valueSearchBar && (
                                    
                                        <TfiClose className="resetTopBar pointer" size={15} onClick={() => {setValueSearchBar("");changeSearchTopBar('')}}/>  )}

                                {
                                    showSearch && suggestions.length > 0 && <div className="containerSuggestion primaryBack" ref={refSearch}>
                                        <ContainerSuggestion suggestions={suggestions} />
                                    </div>
                                }
                        </div>
                        <div className="separation"></div>

                        <div className="icon" ref={refIconCalendar} >
                           <div className= "TopBarSelector pointer lowOpacityHover" onClick={handleCalendar}> 
                            <PiCalendarDotsLight color="black" size={20} />
                            <p className="smallText">{formatSelectedDate(date_selected)}</p>
                            </div> 
                            {date_selected && (
                                
                                <TfiClose
                                    className="resetTopBar pointer"
                                    size={13}
                                    onClick={() => {
                                        clearTimeFilters(setFilterChoose,filterChoose)
                                        setDate_selected(null);
                                        setShowCalendar(false);
                                    }}
                                />
                            )}
                        </div>


                        {
                        showCalendar && (
                            <div className="containerCalendar" ref={refCalendar}>
                                <ContainerCalendar today={today} activeMonth={activeMonth} setActiveMonth={setActiveMonth} setShowCalendar={setShowCalendar} maxDate={maxDate}/>
                            </div>
                        )
                        }

                        <div className="separation"></div>
                        <div className="icon" ref={refIconHour}>
                            <div className="TopBarSelector pointer lowOpacityHover" onClick={() => setShowHour(!showHour)}>
                                <CiClock2 color="black" size={18}  />
                                <p className="smallText">{hour_selected || "Heure"}</p>
                            </div>
                            
                            {hour_selected && (
                                <TfiClose
                                    className="resetTopBar pointer"
                                    size={13}
                                    onClick={() => {
                                        clearTimeFilters(setFilterChoose,filterChoose)
                                        setHour_selected("");
                                        setShowHour(false);
                                    }}
                                />
                            )}
                        </div>
                        {showHour && (
                                <div id="containerHourTopBar" className="containerHourTopBar smallTextBold primaryBack" ref={refHour}>
                                    {timeSlots.map((time, index) => (
                                        <div
                                            key={index}
                                            id={`time-${time.replace("h", "-")}`}
                                            className={`timeSlot ${time === hour_selected && 'select'}`}
                                            onClick={() => {
                                                clearTimeFilters(setFilterChoose,filterChoose)
                                                setHour_selected(time === hour_selected ? '' : time);
                                                setShowHour(false);
                                            }}
                                        >
                                            {time}
                                        </div>
                                    ))}
                                </div>
                            )}
                        
                    {showCity && <div className="containerListCity smallText" ref={refCity}>
                            <ContainerShowCity setSearchCity={setValueSearchCity} clickProximity={clickProximity} suggestionsCity={suggestionsCity} setShowCity={setShowCity} clearProximity={() => {clearProximity(setFilterChoose,filterChoose)}}/>
                        </div>
                    }
            
                </div>
                <IconConnection />
                <div className="TopLeftIconHome" style={{opacity: showChevron ? 1 : 0.4}}>
                    {openTopBar ? 
                        <FiChevronUp size={40} onClick={handleCloseTopBar}/> : <FiChevronDown size={40} onClick={() => {setOpenTopBar(true);setTimeout(()=> {setShowOverflow(true)},200)}}/> }
                </div>
            </div>   

            <div className="filterOnglet primaryBack"  >
                <div onClick={handleClick}>
                    <LiaSlidersHSolid size={25} />
                    <p className="smallTextBold">Filtres</p>
                </div>
                <div style={{marginRight:'1em'}} onClick={handleMap} > 
                <ImMap2 size={20} />
                    <p className="smallTextBold">Map</p>
                </div>

            </div> 
            {activeTopBar && <div className="maskBody"></div>}
        </div>
    )
}

export default TopBar